export default "<i class=\"fas fa-trash-alt\" (click)=\"propagateClick  == 'true' && !disabled && openDialog()\" [ngClass]=\"{'disabled': disabled}\"></i>\r\n"